import { z } from 'zod';
export const pdfGenerationMessageName = 'pdf-generation';
export const printAccountBadgeRequestSchema = z.object({
    accountBadgeId: z.string().uuid(),
});
export const printAccountBadgeResponseSchema = z.object({
    requestId: z.string().uuid(),
});
export const printAccountBadgeFunctionDef = {
    name: 'printAccountBadge',
    requestSchema: printAccountBadgeRequestSchema,
    responseSchema: printAccountBadgeResponseSchema,
};
